import styled from '@emotion/styled'
import { Stack, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import HelpTooltip, { MobileTooltipWithIcon } from '../tooltips/HelpTooltip'

const TabsTitle = ({ children, color }: { children: React.ReactNode; color?: string }) => {
  return (
    <Typography
      variant="body1"
      fontWeight={400}
      fontSize="1.1rem"
      color={color}
      textTransform="none"
    >
      {children}
    </Typography>
  )
}

const TooltipDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const GetTitle = ({ text, color, tooltip }: { text: string; color?: string; tooltip?: string }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const item = <TabsTitle color={color}>{text}</TabsTitle>

  if (!tooltip) {
    return item
  }

  // Desktop: tooltip on hover over entire tab
  if (!isMobile) {
    return (
      <HelpTooltip text={tooltip}>
        <TooltipDiv>{item}</TooltipDiv>
      </HelpTooltip>
    )
  }

  // Mobile: text + info icon with clickable tooltip
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <TabsTitle color={color}>{text}</TabsTitle>
      <MobileTooltipWithIcon text={tooltip} placement="bottom" />
    </Stack>
  )
}

export const getTitle = (text: string, color?: string, tooltip?: string) => {
  return <GetTitle text={text} color={color} tooltip={tooltip} />
}

export default React.memo(TabsTitle)
